import { MenuHeader, ThemeComponentSwitcher } from 'lib_ui-primitives';
import Gl2025MenuHeader from './MenuHeader.gl2025';

let SwitchedComponent = ThemeComponentSwitcher([
    {
        theme: 'gl2025',
        component: Gl2025MenuHeader
    },
    { component: MenuHeader }
]);
export default SwitchedComponent;
